// extracted by mini-css-extract-plugin
export var circle = "_3l-2";
export var icon = "_3l-a";
export var iconHighlight = "_3l-0";
export var lg = "_3l-8";
export var md = "_3l-7";
export var outline = "_3l-4";
export var sm = "_3l-6";
export var square = "_3l-1";
export var xl = "_3l-9";
export var xs = "_3l-5";
export var xxs = "_3l-3";